// GENERATED FROM brands.json — DO NOT EDIT BY HAND.
// Edit brands.json and run `npm run build`.

/** @type {import('./brands.d.ts').BrandKit} */
export const BRANDS = {
  "bwrm": {
    "id": "bwrm",
    "displayName": "BWRM",
    "poweredBy": "Bookings powered by BWRM",
    "tagline": null,
    "tokens": {
      "brand": "#1a1818",
      "brandAccent": "#0093b2",
      "accentInk": "#00708a",
      "accentHover": "#00708a",
      "onAccent": "#ffffff",
      "ink": "#1a1818",
      "muted": "#4a5560",
      "line": "#dde4ea",
      "paper": "#ffffff",
      "surface": "#f5f7f9",
      "fontFamily": "'Montserrat', ui-sans-serif, system-ui, sans-serif"
    },
    "tokensDark": {
      "brand": "#ffffff",
      "brandAccent": "#22b8d9",
      "accentInk": "#22b8d9",
      "accentHover": "#4dd0ee",
      "onAccent": "#101012",
      "ink": "#f4f4f5",
      "muted": "#9aa2ab",
      "line": "#27272a",
      "paper": "#101012",
      "surface": "#18181b",
      "fontFamily": "'Montserrat', ui-sans-serif, system-ui, sans-serif"
    },
    "fontHref": "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap",
    "type": {
      "bodyWeight": 400,
      "headingWeight": 700,
      "headingTracking": "-0.01em"
    },
    "radius": {
      "control": "12px",
      "card": "16px",
      "pill": "999px"
    },
    "shadow": {
      "card": "0 1px 2px rgba(26, 24, 24, 0.04), 0 4px 16px rgba(26, 24, 24, 0.05)"
    },
    "shadowDark": {
      "card": "0 1px 2px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.45)"
    },
    "logos": {
      "primary": {
        "onLight": "assets/bwrm/primary-on-light.svg",
        "onDark": "assets/bwrm/primary-on-dark.svg"
      },
      "secondary": {
        "onLight": "assets/bwrm/secondary-on-light.svg",
        "onDark": "assets/bwrm/secondary-on-dark.svg"
      },
      "social": {
        "onLight": "assets/bwrm/social-on-light.svg",
        "onDark": "assets/bwrm/social-on-dark.svg"
      },
      "poweredBy": {
        "onLight": "assets/bwrm/powered-by-on-light.svg",
        "onDark": "assets/bwrm/powered-by-on-dark.svg"
      }
    },
    "icons": null
  },
  "luxengine": {
    "id": "luxengine",
    "displayName": "LUXengine",
    "poweredBy": "Bookings powered by LUXengine",
    "tagline": "",
    "tokens": {
      "brand": "#221e17",
      "brandAccent": "#d9a441",
      "accentInk": "#7a5510",
      "accentHover": "#c08f30",
      "onAccent": "#f7f4ec",
      "ink": "#221e17",
      "muted": "#6d6553",
      "line": "#ddd5c4",
      "paper": "#f7f4ec",
      "surface": "#ffffff",
      "fontFamily": "'Montserrat', ui-sans-serif, system-ui, sans-serif"
    },
    "tokensDark": {
      "brand": "#f5f1e8",
      "brandAccent": "#d9a441",
      "accentInk": "#d9a441",
      "accentHover": "#f0c874",
      "onAccent": "#08070a",
      "ink": "#f5f1e8",
      "muted": "#9a96a3",
      "line": "#2a2831",
      "paper": "#08070a",
      "surface": "#111014",
      "fontFamily": "'Montserrat', ui-sans-serif, system-ui, sans-serif"
    },
    "fontHref": "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&display=swap",
    "type": {
      "bodyWeight": 400,
      "headingWeight": 600,
      "headingTracking": "-0.025em"
    },
    "radius": {
      "control": "4px",
      "card": "16px",
      "pill": "999px"
    },
    "shadow": {
      "card": "0 1px 2px rgba(34, 30, 23, 0.04), 0 4px 16px rgba(34, 30, 23, 0.05)"
    },
    "shadowDark": {
      "card": "0 1px 2px rgba(0, 0, 0, 0.6), 0 4px 16px rgba(0, 0, 0, 0.5)"
    },
    "logos": {
      "primary": {
        "onLight": "assets/luxengine/primary-on-light.svg",
        "onDark": "assets/luxengine/primary-on-dark.svg",
        "onLightRaster": "assets/luxengine/primary-on-light@3x.png",
        "onDarkRaster": "assets/luxengine/primary-on-dark@3x.png"
      }
    },
    "icons": {
      "svg": "assets/luxengine/icon.svg",
      "png": {
        "16": "assets/luxengine/icon-16.png",
        "32": "assets/luxengine/icon-32.png",
        "48": "assets/luxengine/icon-48.png"
      },
      "appleTouch": "assets/luxengine/app-icon.png"
    }
  }
};

export const BRAND_IDS = ["bwrm","luxengine"];

export const DEFAULT_BRAND_ID = "bwrm";

export const KIT_VERSION = 1;

/** Whether a value is a brand this kit defines. Casing is exact on purpose:
 *  PRISM is upstream and its values are not ours to trust. */
export function isBrandId(value) {
  return typeof value === 'string' && BRAND_IDS.includes(value);
}

/** The brand a member belongs to, given whatever the upstream systems claim.
 *  Anything unrecognised degrades to the default rather than rendering nothing. */
export function resolveBrand(...candidates) {
  for (const candidate of candidates) {
    if (isBrandId(candidate)) return BRANDS[candidate];
  }
  return BRANDS[DEFAULT_BRAND_ID];
}

/** WCAG relative luminance. Exported so the runtime logo choice and the kit's
 *  own contrast tests cannot disagree about what "light" means. */
export function luminance(hex) {
  const c = [1, 3, 5]
    .map((i) => parseInt(hex.slice(i, i + 2), 16) / 255)
    .map((v) => (v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}

/** Which logo variant belongs on a given background colour.
 *
 *  Handles the case the onLight/onDark names alone do not: a mark on a filled
 *  gold panel is on a DARK ground even though the page around it is light. */
export function onGround(hex) {
  return luminance(hex) > 0.4 ? 'onLight' : 'onDark';
}

/** The logo file for a brand, or null.
 *
 *  Never guesses. Only the primary lockup is guaranteed to exist, so a caller asking
 *  for a lockup a brand does not have gets null and can fall back to text,
 *  which is what the booking system's attribution line already does. */
export function logoFor(brand, options = {}) {
  const record = typeof brand === 'string' ? BRANDS[brand] : brand;
  const pair = record?.logos?.[options.lockup ?? 'primary'];
  if (!pair) return null;
  const variant =
    options.on ? onGround(options.on)
    : options.scheme === 'dark' ? 'onDark'
    : 'onLight';
  return pair[variant] ?? null;
}

/** The CSS custom property a token maps to, for apps that set them at runtime. */
export function cssVarName(token) {
  if (token === 'fontFamily') return '--font-brand';
  return `--color-${token.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`)}`;
}
